import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import BackMethods from "../../back_component/BackMethods";
import User from "../../models/User";

export default function LoginPage() {
  const { backEnd_request, setToken } = BackMethods();

  const [user, setUser] = useState(new User());
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [formError, setFormError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (field, value) => {
    setUser((prev) => new User({ ...prev, [field]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!user.username?.trim()) newErrors.userName = "الرجاء إدخال اسم المستخدم";
    if (!user.password?.trim()) newErrors.password = "الرجاء إدخال كلمة المرور";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError("");

    if (!validate()) return;

    setIsSubmitting(true);
    try {
      const res = await backEnd_request.post("auth/login", user.toLoginApi());
      console.log(res);
      if (res.data.user.userType == "Web")
        setToken(res.data);
      else
        setFormError("اسم المستخدم أو كلمة المرور غير صحيحة");

    } catch (error) {
      console.log(error);
      setFormError("اسم المستخدم أو كلمة المرور غير صحيحة");
    } finally {
      setIsSubmitting(false);
    }
  };

  const togglePassword = () => setShowPassword(!showPassword);

  return (
    <div className="bg-dark min-vh-100 d-flex align-items-center">
      <div className="container">

        <div className="text-center mb-5">
          <h1
            className="text-light fw-bold"
            style={{ fontSize: "2.5rem", letterSpacing: "1px" }}
          >
            مرحباً بك
          </h1>
          <p className="text-light" style={{ fontSize: "1.1rem" }}>
            أكمل المعلومات اللازمة لتسجيل الدخول
          </p>
        </div>

        <div className="d-flex justify-content-center">
          <div
            className="card border-0 shadow-lg"
            style={{
              width: "100%",
              maxWidth: "450px",
              borderRadius: "20px",
            }}
          >
            <div
              className="card-header text-center py-4"
              style={{
                backgroundColor: "#f8f9fa",
                borderTopLeftRadius: "20px",
                borderTopRightRadius: "20px",
              }}
            >
              <h3 className="text-dark m-0 fw-bold">تسجيل الدخول</h3>
            </div>

            <div className="card-body bg-white p-5 rounded-bottom">
              <form onSubmit={handleSubmit} noValidate>
                {/* 🧍‍♂️ اسم المستخدم */}
                <div className="mb-4">
                  <input
                    type="text"
                    className={`form-control form-control-lg ${errors.userName ? "is-invalid" : ""
                      }`}
                    placeholder="اسم المستخدم"
                    value={user.username || ""}
                    onChange={(e) => handleChange("username", e.target.value)}
                    style={{
                      borderRadius: "12px",
                      paddingRight: "15px",
                    }}
                  />
                  {errors.userName && (
                    <div className="invalid-feedback text-end">
                      {errors.userName}
                    </div>
                  )}
                </div>

                {/* 🔒 كلمة المرور + أيقونة العين */}
                <div className="mb-4 position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    className={`form-control form-control-lg ${errors.password ? "is-invalid" : ""
                      }`}
                    placeholder="كلمة المرور"
                    value={user.password || ""}
                    onChange={(e) => handleChange("password", e.target.value)}
                    style={{
                      borderRadius: "12px",
                      paddingLeft: "45px",
                      paddingRight: "15px",
                    }}
                  />
                  <span
                    onClick={togglePassword}
                    role="button"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "15px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6c757d",
                    }}
                  >
                    {showPassword ? (
                      <FaEye size={20} />
                    ) : (
                      <FaEyeSlash size={20} />
                    )}
                  </span>
                  {errors.password && (
                    <div className="invalid-feedback text-end">
                      {errors.password}
                    </div>
                  )}
                </div>

                {/* زر الإرسال */}
                <div className="mb-4">
                  <button
                    type="submit"
                    className={`btn w-100 py-3 fw-bold ${isSubmitting ? "btn-secondary" : "btn-dark text-light"
                      }`}
                    style={{ borderRadius: "12px", fontSize: "1.1rem" }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "انتظر..." : "تسجيل الدخول"}
                  </button>
                </div>

                {/* خطأ عام */}
                {formError && (
                  <div className="text-danger text-center mt-3 fw-bold">
                    {formError}
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
